<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup MST_004
 * @created at      :   2026/01/21
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupMST004 from '@/views/popupSearch/PopupMST004/store';
import helpers from '@/utils/helpers';

var PopupMST004Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupMST004')) {
            store.registerModule('PopupMST004', PopupMST004);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName'],
    computed: {
        ...mapState('PopupMST004', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupMST004', ['searchCenterInfo']),
        ...mapMutations('PopupMST004', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.company_cd = this.initData;
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchCenterInfo(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchCenterInfo(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.center_cd);
            this.$emit('onReferValueName', item.center_name);
            this.$emit('close');
        }
    }
};
export default PopupMST004Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
